import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles, MenuItem, Menu, ListItemIcon} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { HeaderStyle } from './Header.style';
import { ISuggestion } from '@app-types/websocket/suggestion.types';
import * as UserActions from '@services/user/user.actions';
import { ICalendarSetting } from '@app-types/websocket/user.types';
import WorldIcon from '@material-ui/icons/LanguageRounded';
import ExportIcon from '@material-ui/icons/ExitToAppRounded';
import DateRangeRounded from '@material-ui/icons/DateRangeRounded';
import { IExternalCalendar } from '@app-types/websocket/externalCalender.types';
import CordovaContext from 'src/cordovaContext';
import { getSelectedFamilyResource } from '@services/user/user.utils';

const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof HeaderStyle> {
  reference:React.RefObject<HTMLDivElement>;
  open:boolean;
  close:() => void;

  externalCalendars: IExternalCalendar[];

  showExternalCalendarSettings: () => void;
  showExternalCalendarImport: () => void;
  showLocalImport : () => void;
  showExport: () => void;
}

class ImportOtherCalendarMenu extends React.Component<IProps> {

  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const {classes} = this.props;

    return (
      <Menu
        anchorEl={this.props.reference.current}
        open={this.props.open}
        anchorReference="anchorEl"
        onClose={() => {this.props.close();}}
        transformOrigin={{vertical: 'top', horizontal: 'center'}}
        classes={{
          paper: classes.menuPaper,
          list: classes.menuList,
        }}
      >
                  
        <MenuItem
          onClick={() => {
            this.props.showExternalCalendarSettings();
            this.props.close();
          }}
          className={classes.menuListItem}>
          <ListItemIcon>
            <WorldIcon />
          </ListItemIcon>
          <div className={classes.menuItemTitle}>
            {tn.lang.externalCalImportViaUrl}
          </div>
        </MenuItem>
        
        <CordovaContext.Consumer>
          {(cordovaApp) => {
            return (
              <MenuItem
                disabled={(!cordovaApp)}
                onClick={(event:any) => {this.props.showLocalImport(); this.props.close()}}
                className={classes.menuListItem}>
                <ListItemIcon>
                  <DateRangeRounded />
                </ListItemIcon>
                <div className={classes.menuItemTitle}>
                  {tn.lang.showLocalCal}
                </div>
              </MenuItem>
            );
          }}
        </CordovaContext.Consumer>

        <MenuItem
          onClick={() => {
            this.props.showExport();
            this.props.close();
          }}
          className={classes.menuListItem}>
          <ListItemIcon>
            <ExportIcon />
          </ListItemIcon>
          <div className={classes.menuItemTitle}>
            {tn.lang.synchCal}
          </div>
        </MenuItem>
      </Menu>
    );
  }
}



function mapStateToProps(state: any) {
  let externalCalendars: IExternalCalendar[] = state.externalCalendar.externalCalendars || [];

  let myFamilyId = 0;
  const myFam = getSelectedFamilyResource(state.user?.session);
  if (myFam?.id !== undefined) {
      myFamilyId = myFam.id;
  }

  externalCalendars = externalCalendars.filter((cal) => cal.familyId === myFamilyId);
  return {
    externalCalendars,
  };
}

const mapDispatchToProps = {
  setShowWeekNum: UserActions.setShowWeekNum,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(HeaderStyle)(ImportOtherCalendarMenu));



// WEBPACK FOOTER //
// ./src/components/calendar2/header/ImportOtherCalendarMenu.tsx